import { useEffect, useState } from 'react'

const pad = (value: number) => String(value).padStart(2, '0')

/**
 * Counts down from `seconds` to 0 and restarts automatically.
 * Returns zero-padded minutes and seconds.
 */
export function useCountdown(seconds: number) {
  const [remaining, setRemaining] = useState(seconds)

  useEffect(() => {
    const id = setInterval(() => {
      setRemaining((prev) => (prev <= 1 ? seconds : prev - 1))
    }, 1000)
    return () => clearInterval(id)
  }, [seconds])

  return {
    minutes: pad(Math.floor(remaining / 60)),
    seconds: pad(remaining % 60),
    remaining,
  }
}
